export default "__VITE_ASSET__ff7c0e76__"